export enum TerminalStatusDescriptionEnum {
  NOWY = 'devices.readers.status.new',
  PODMIENIONY = 'devices.readers.status.replaced',
  OK = 'devices.readers.status.ok',
  AWARIA = 'devices.readers.status.failure',
  USUNIETY = 'devices.readers.status.deleted',
}
